import { render, staticRenderFns } from "./CotPuaViewPage.vue?vue&type=template&id=3bcdac0e"
import script from "./CotPuaViewPage.vue?vue&type=script&lang=js"
export * from "./CotPuaViewPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports